// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u1-2";
export var chatLink = "_u1-0";
export var chatText = "_u1-1";